export const Constants = {
  GET_DATA: 'Stats.GET_DATA',
  SET_DATA: 'Stats.SET_DATA',
  SET_LOADING: 'Stats.SET_LOADING',
  GET_DATA_API: '/api/v1/report/dashboard_doanh_so_trong_thang'
}

export const getData = (formData) => {
  return {
    type: Constants.GET_DATA,
    payload: formData
  }
}

export const setData = (data) => {
  return {
    type: Constants.SET_DATA,
    payload: data
  }
}

export const setLoading = (flag) => {
  return {
    type: Constants.SET_LOADING,
    payload: flag
  }
}


// WEBPACK FOOTER //
// ./src/components/Stats/actions.js